export const ROLES_LIST = 'ROLES_LIST'
export const USER_LIST = 'USER_LIST'
export const PLACE_LIST = 'PLACE_LIST'
export const BUSSTATION_LIST = 'BUSSTATION_LIST'
export const CORPORATION_LIST = 'CORPORATION_LIST'
export const DIVISION_LIST = 'DIVISION_LIST'
export const COUNTERS_FILTER = 'COUNTERS_FILTER'
export const DEPOT_LIST = 'DEPOT_LIST'
export const BTOB_BTOC_USER_LIST = 'BTOB_BTOC_USER_LIST'
export const UPDATE_USER_DEPARTMENT = 'UPDATE_USER_DEPARTMENT'
export const UPDATE_USER_LEVEL = 'UPDATE_USER_LEVEL'